
import { useQuery } from "@tanstack/react-query";
import { vehiculoXID } from "../../../services";




export const useVehiculosXID = (id) => {

    const { data, isLoading } = useQuery({
        queryKey: ['vehiculo-id', id], 
        queryFn: () => vehiculoXID(id),
        enabled: !!id,
    });

    return { data, isLoading }
}





// export const useUsuariosTodosRol = (rol) => {
    
//     const [page, setPage] = useState(0);
//     const [termino, setTermino] = useState('');


//     const todoUsuariosQuery = useQuery({
//         queryKey: ['usuarios-rol', { page, termino, rol }], 
//         queryFn: () => listadoUsuariosRol({ page, termino, rol }),
//     });


//     const chagePage = (num) => {
//         setPage(num - 1);
//     }


//     const chageTermino = (valor) => {
//         setPage(0);
//         setTermino(valor)
//     }


    
    
//     return {
//         // Estados
//         page,
//         termino,
//         // Metodos
//         chagePage,
//         chageTermino,
//         todoUsuariosQuery,
//     }
// }
